// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"790":"5019af2b","5856":"eefbfaec","6145":"ff7a54b4","7070":"b6b4aa15","8430":"664b04a5"}[chunkId] + ".chunk.css";
};